import React from "react";
import { IconButton, InputGroup, MaskedInput, Stack } from "rsuite";
import CopyIcon from '@rsuite/icons/Copy';
import {MaskFunctionType} from "rsuite/cjs/MaskedInput/types";
import {GpsCoordinatesControlProps} from "./GpsCoordinatesControl.model";

const GpsCoordinatesControl = (
  {
    latitudeDirection,
    latitude,
    longitudeDirection,
    longitude,
    onCopy
  }: GpsCoordinatesControlProps) => {
    const handleCopy = async (): Promise<void> => {
        try {
            const text = `${latitude.substring(0, latitude.length - 4)}.${latitude.substring(latitude.length - 4)} ` +
                `${longitude.substring(0, longitude.length - 4)}.${longitude.substring(longitude.length - 4)}`;

            await navigator.clipboard.writeText(text);
            console.log('Координаты скопированы:', text);

            onCopy?.();  // вызов коллбека если передан
        } catch (error: unknown) {
            console.error('Ошибка копирования:', error);
        }
    };

    const maskFunction: MaskFunctionType = (rawValue: string): (string | RegExp)[] => {
        if (rawValue.replace(/\D/gi, "").length > 6) {
            return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
        }
        return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
    };

    return (
        <Stack className="pt-2">
            <InputGroup>
                <InputGroup inside>
                    <InputGroup.Addon style={{ width: "30px" }}>
                        {latitudeDirection}
                    </InputGroup.Addon>
                    <MaskedInput
                        readOnly={true}
                        value={latitude}
                        mask={maskFunction}
                        showMask={false}
                        guide={false}
                        keepCharPositions={false}
                        placeholderChar="_"
                        style={{ width: "100px" }}
                    />
                </InputGroup>

                <InputGroup inside>
                    <InputGroup.Addon style={{ width: "30px" }}>
                        {longitudeDirection}
                    </InputGroup.Addon>
                    <MaskedInput
                        readOnly={true}
                        value={longitude}
                        mask={maskFunction}
                        showMask={false}
                        guide={false}
                        keepCharPositions={false}
                        placeholderChar="_"
                        style={{ width: "100px" }}
                    />
                </InputGroup>

                <InputGroup.Addon>
                    <IconButton
                        onClick={handleCopy}
                        icon={<CopyIcon />}
                        appearance="subtle"
                    />
                </InputGroup.Addon>
            </InputGroup>
        </Stack>
    );
};

export default GpsCoordinatesControl;
